import { useContext } from "react";

import { StepperContext } from "../../Contexts/Stepper";
import "./Stepper.css";

export const Stepper = () => {
  const { step } = useContext(StepperContext);

  return (
    <div id="progress-bar">
      <ul>
        {[1, 2, 3, 4].map((currentStep) => (
          <li className={step >= currentStep && "active"}></li>
        ))}
      </ul>
    </div>
  );
};
